export default "__VITE_ASSET__a789fff1__"